import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, inject, OnDestroy, OnInit, TemplateRef, ViewChild, } from '@angular/core';
import { faFileExcel, faRectangleList, faTrashCan, } from '@fortawesome/free-regular-svg-icons';
import { faChevronLeft, faPrint } from '@fortawesome/free-solid-svg-icons';
import { ModalDismissReasons, NgbModal, NgbPopover, NgbPopoverConfig, } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  Images,
  OccEndpointsService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as _ from 'underscore';
import { CustomProdPgService } from '../../../custom-prod-pg/custom-prod-pg.service';
import { Cart, CartItemEntry, CartsApi, CartType, CustomCartItemEntry, EntryUpdateParams } from '../../../shared/model/cart.model';
import { PriceChannel } from '../../../shared/model/price-channel.model';
import { CustomProduct } from '../../../shared/model/product.model';
import { DataLayerService } from '../../../shared/services/data-layer.service';
import { ProductUtils } from '../../../shared/utils/productUtils';
import { CustomAddToCartService } from '../../custom-add-to-cart.service';
import { ProductDetailsComponent } from '../product-details/product-details.component';
import { StandartCartItem } from './standard-cart-model';

const MESSAGE_TIMEOUT = 5000;
const SCROLL_OFFSET = 400;

const SPECIAL_CHARS_OMIT = /^[^`!@#~$%^&*()_+\-={};':"\\|[\].,<>\/?]*$/;

@Component({
  selector: 'app-standard-cart',
  templateUrl: './standard-cart.component.html',
  styleUrls: ['./standard-cart.component.scss'],
  standalone: false
})
export class StandardCartComponent implements OnInit, OnDestroy {
  protected readonly iconTypes = ICON_TYPE;
  protected readonly PriceChannel = PriceChannel;
  protected readonly ProductUtils = ProductUtils;
  isSticky: boolean = false;
  productInfo: CustomProduct = null;
  standardCartDetails: any;
  productEntries: CartItemEntry[] = [];
  images: Images;
  isAsmEnabled: boolean;
  updateTotal: boolean;
  updateEntriesData: EntryUpdateParams[] = [];
  subTotal: number;
  baseUrl: string;
  minDeliveryDate = new Date();
  maxDeliveryDate = new Date();
  minPickupDate = new Date();
  maxPickupDate = new Date();
  currentTime = new Date().getHours();
  pickupTimeFormat: any = [];
  selectedTime: any;
  deliveryDate: Date;
  deliveryCrossIcon: boolean;
  pickupDate: Date;
  deliveryDateFormat: string;
  pickupCrossIcon: boolean;
  fallbackImage = 'i18n-assets/sanofiwebb_missing_product.png';
  closeResult = '';
  usergetDataObj: any;
  getuserData: any;
  searchedClientList: any;
  selectedData: any;
  soldToData: any;
  listSelectedData: any;
  userAccountgetData: any;
  saveCartName: string;
  cartId: any;
  errorMsg: string;
  deleteSuccess: string;
  addSuccess = false;
  cartItems: any;
  changeLocation = false;
  templatePage: any;
  insufficientStockProducts: Map<number, number> = new Map();
  prodAddedSub: Subscription;
  cartItemsSub: Subscription;
  removeEntriesSub: Subscription;
  deleteCartSub: Subscription;
  cartDetailsSub: Subscription;
  checkoutDetailsSub: Subscription;
  checkoutFailedSub: Subscription;
  userAccountDetailsSub: Subscription;
  changedLocSub: Subscription;
  saveCartInvalidSub: Subscription;
  saveCartSuccessSub: Subscription;
  plpMiniCartSub: Subscription;
  userDataSub: Subscription;
  saveRemovedSub: Subscription;
  @ViewChild('p2') public savePopover: NgbPopover;
  orderBlock = false;
  showDangerAlert = false;
  checkoutClicked = false;
  yfEntry = false;
  quickOrderRemovedEntry: boolean = false;
  // icons
  faPrint = faPrint;
  faFileExcel = faFileExcel;
  faTrashCan = faTrashCan;
  faRectangleList = faRectangleList;
  faChevronLeft = faChevronLeft;
  cartDetailsRan = false;
  selectedChannel: PriceChannel;
  showDisclaimer = false;
  csAgentAuthSubscription: Subscription;
  slobStatus = false;
  quantityBtnDisabled = false;
  shouldUpdateCart = false;
  private translations: Subscription;
  private eanTranslation: string;
  private shipToTranslation: string;
  private cartTranslation: string;
  private unitsTranslation: string;

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly addToCart = inject(CustomAddToCartService);
  private readonly user = inject(UserAccountFacade);
  private readonly modalService = inject(NgbModal);
  private readonly localeService = inject(BsLocaleService);
  private readonly datepipe = inject(DatePipe);
  private readonly config = inject(NgbPopoverConfig);
  private readonly route = inject(RoutingService);
  private readonly occEndPoint = inject(OccEndpointsService);
  private readonly plpService = inject(CustomProdPgService);
  private readonly globalMessage = inject(GlobalMessageService);
  private readonly pageDate = inject(CmsService);
  private readonly dataLayerService = inject(DataLayerService);
  private readonly csAgentAuthService = inject(CsAgentAuthService);
  private readonly translationService = inject(TranslationService);

  constructor() {
    this.images = {};
    this.updateTotal = false;
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
    this.pickupTimeFormat = [
      '09:00 am',
      '10:00 am',
      '11:00 am',
      '12:00 pm',
      '01:00 pm',
      '02:00 pm',
      '03:00 pm',
      '04:00 pm',
      '05:00 pm',
    ];
    this.selectedTime = null;
    this.config.autoClose = 'outside';
    this.deleteSuccess = '';
    this.addSuccess = false;
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.scrollY >= SCROLL_OFFSET;
  }

  ngOnInit(): void {
    this.getTranslations();
    this.selectedChannel = sessionStorage.getItem('selectedChannel') as PriceChannel;
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);

    this.plpMiniCartSub = this.plpService.getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(res, this.userAccountgetData?.userName);
          this.addToCart.removeEntriesMapping();
        }
      });
    this.plpService.stdCartMsg.next(false);
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      if (res) {
        this.templatePage = res?.template;
      }
    });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res) {
        this.userAccountgetData = res;
        this.getUserAccountData();
        this.productEntries = [];
        this.getCartDetails();
        this.cdr.detectChanges();
      }
    });
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated()
      .subscribe((res) => {
        this.isAsmEnabled = res;
      });
    this.prodAddedSub = this.plpService.stdCartMsg$.subscribe((res) => {
      if (res) {
        this.addSuccess = true;
        this.deleteSuccess = '';
        this.plpService.stdCartMsg.next(false);
      }
    });
    this.setDeliveryDate();
    this.setPickupDate();
    this.cartErrorsHandler();
    this.onCartUpdate();
  }

  getCartDetails(): void {
    this.cartItemsSub = this.addToCart.cartItems$.subscribe((cartData: any) => {
      if (cartData) {
        this.cartDataMapping(cartData);
      }
    });

    if (this.cartId === undefined) {
      this.cartId = this.addToCart.cartId;
    }

    if (this.cartId && this.templatePage === 'CartPageTemplate') {
      this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.userName);
      this.addToCart.removeEntriesMapping();
    }
  }

  cartDataMapping(data: CartsApi): void {
    this.productEntries = [];
    this.showDisclaimer = true;
    this.cartId = data?.code;

    const stdCartDetails = data?.childCarts.filter(item => item.cartType === CartType.STANDARD);

    if (!stdCartDetails.length) {
      return;
    }

    if (!this.cartDetailsRan) {
      //if that thing hasn't happened yet and the mouse is pressed
      this.cartDetailsRan = true;
      this.dataLayerService.viewCartDataLayer(stdCartDetails);
    }


    this.standardCartDetails = Object.assign({}, ...stdCartDetails);

    this.generateProductEntries(stdCartDetails, data);

    if (this.shouldUpdateCart) {
      this.updateCart();
    }

    if (this.standardCartDetails?.deliveryAddress) {
      this.selectedData = this.standardCartDetails?.deliveryAddress;
    } else if (this.getuserData && this.getuserData?.length > 0) {
      this.selectedData = _.first(this.getuserData.filter((item: any) => item.unitID === this.userAccountgetData?.uid));
    }

    this.soldToData = null;
    this.saveCartName = this.selectedData?.companyName?.slice(0, 30);
    this.cdr.detectChanges();

  }

  performQuantityComputation(operator: number | null, productEntry: StandartCartItem): void {
    const idData = productEntry?.entryNumber.toString();
    const quantityOfUnits = productEntry?.product?.quantityPerUnit;
    const entryNumber = productEntry.entryNumber;
    const numberOfUnitsPerCarton = productEntry?.product?.numberOfUnitsPerCarton;
    const conditionsForCartonsLogicMeet = productEntry?.conditionsForCartonsLogicMeet;
    ProductUtils.alterQuantity(
      operator,
      idData,
      quantityOfUnits,
      this.selectedChannel,
      conditionsForCartonsLogicMeet ? numberOfUnitsPerCarton : 0
    );

    this.checkoutClicked = false;
    this.updateTotal = true;
    const inputElement = document.getElementById(`prodQuantity${idData}`) as HTMLInputElement;
    this.updateQuantityEntriesData(entryNumber, inputElement.value);

    if (this.selectedChannel === PriceChannel.PUBLIC) {
      this.checkMaxQuantities(entryNumber, +inputElement.value);
    }
  }

  getMaxQuantity(entryNumber: number): number {
    const sapEntryNumber: number = (entryNumber + 1) * 10;
    return this.insufficientStockProducts.get(sapEntryNumber);
  }

  deleteCart(entryNumber: number, prodName: string): void {
    this.addToCart.deleteCartItem(
      entryNumber,
      this.standardCartDetails.code,
      this.cartId
    );

    this.deleteCartSub = this.addToCart.deleteItems$.subscribe((res) => {
      if (res) {
        this.addToCart.deleteItems.next(false);
        this.addToCart.removedEntries(
          this.cartId,
          this.userAccountgetData?.userName
        );
        this.addToCart.removeEntriesMapping();
        this.deleteSuccess = prodName;
        this.addSuccess = false;
      }
    });
  }

  closeAlert(): void {
    this.deleteSuccess = '';
    this.addSuccess = false;
  }

  closeDangerAlert(): void {
    this.showDangerAlert = false;
  }

  clearChildCart(): void {
    sessionStorage.removeItem('seletedContract');
    sessionStorage.removeItem('contractFromCartApi');
    sessionStorage.removeItem('contractFromCartApiName');
    this.addToCart.clearCart(this.standardCartDetails.code);
  }

  toggle(popover: NgbPopover): void {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';
    this.saveCartName = this.selectedData?.companyName?.slice(0, 30);
  }

  updateCart(): void {
    this.addToCart.updateCartDetails(this.standardCartDetails.code, this.updateEntriesData, this.cartId);
  }

  productDetails(productDetails: CartItemEntry): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: 'product-details-modal',
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = this.standardCartDetails.code;
    modalRef.componentInstance.unitSection = 'Update';
  }

  onDeliveryDateChange(value: Date): void {
    if (value) {
      this.deliveryCrossIcon = true;
      this.deliveryDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
    } else {
      this.deliveryCrossIcon = false;
    }
  }

  clearDate(dpDate: string): void {
    if (dpDate === 'Delivery') {
      this.deliveryDate = null;
      this.deliveryCrossIcon = false;
    } else {
      this.pickupDate = null;
      this.pickupCrossIcon = false;
      this.selectedTime = null;
    }
  }

  checkBoxSlobClicked(e): void {
    this.slobStatus = e?.target?.checked;
  }

  proceedToCheckout(): void {
    if (this.deliveryDate) {
      this.onDeliveryDateChange(this.deliveryDate);
      const params = {
        customerId: this.usergetDataObj.uid,
        date: this.deliveryDateFormat,
        deliveryMode: 'standard',
        pickupTime: '',
        shipToUnitId: this.selectedData?.unitID,
        standard: true,
      };
      if (this.isAsmEnabled) {
        Object.assign(params, { slob: this.slobStatus });
        if (this.slobStatus) {
          sessionStorage.setItem('isSlobChecked', 'true');
        } else {
          sessionStorage.setItem('isSlobChecked', 'false');
        }
      }
      this.addToCart.checkoutCart(params, this.cartId);
      this.checkoutClicked = true;
      this.checkoutDetailsSub = this.addToCart.checkoutDetails$
        .pipe(
          filter(res => !!res),
        )
        .subscribe(() => {
            this.checkoutClicked = false;
            this.route.goByUrl('/checkout');
          }
        );
      this.checkoutFailedSub = this.addToCart.checkoutFailed$
        .pipe(
          filter(res => !!res),
        )
        .subscribe((res) => {
            this.checkoutClicked = false;

            if (res.error.errors[0].message) {
              this.processErrorMessage(res.error.errors);
              this.cdr.detectChanges();
            }
          }
        );
    }
  }

  isStockInsufficient(entryNumber: number): boolean {
    const maxQuantity: number = this.getMaxQuantity(entryNumber);
    const inputElement = document.getElementById(
      `prodQuantity${entryNumber}`
    ) as HTMLInputElement;
    return maxQuantity !== undefined && maxQuantity < +inputElement.value;
  }

  open(content: TemplateRef<any>): void {
    this.searchedClientList = this.getuserData.sort((a, b) =>
      a.sapCustomerID < b.sapCustomerID ? -1 : 1
    );
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getUserAccountData(): void {
    this.userAccountDetailsSub = this.addToCart.userAccountDetails$.subscribe(userDataGet => {
        if (!userDataGet) {
          return;
        }

        this.usergetDataObj = userDataGet.res;
        this.getuserData = userDataGet.res.shippingAddresses;
        this.searchedClientList = userDataGet.res.shippingAddresses;
        this.orderBlock = !!userDataGet?.res?.orderBlockFlag;
        if (this.orderBlock) {
          this.showDangerAlert = true;
        }
        this.changeLocation = this.getuserData?.length > 1;
        this.cdr.detectChanges();
      }
    );
  }

  onOptionsSelected(data: any): void {
    this.listSelectedData = data;
  }

  onSubmit(): void {
    if (this.listSelectedData !== undefined) {
      this.selectedData = this.listSelectedData;
      this.addToCart.saveLocation(
        this.selectedData?.unitID,
        this.cartId,
        this.userAccountgetData?.userName
      );
      this.changedLocSub = this.addToCart.changedLocation$.subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(
            this.cartId,
            this.userAccountgetData?.userName
          );
          this.addToCart.removeEntriesMapping();
        }
      });
    }
  }

  SearchClientName(data: any) {
    if (!data.length) {
      this.searchedClientList = this.getuserData;

      return;
    }

    this.searchedClientList = this.getuserData.filter(x => {
      return ['companyName', 'unitID', 'line1', 'line2', 'town', 'postalCode', 'cnpjNumber'].some(field => {
        return x[field]?.toLowerCase().includes(data.toLowerCase());
      });
    });
  }

  saveOrder(): void {
    if (this.saveCartName && RegExp(SPECIAL_CHARS_OMIT).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId);
      this.saveCartInvalidSub = this.addToCart.invalidCartName$
        .pipe(
          filter(res => !!res)
        )
        .subscribe(res => {
          res?.error?.errors.forEach(error => {
            this.errorMsg = error?.message;
          });
        });

      this.saveCartSuccessSub = this.addToCart.saveCartSuccess$
        .pipe(
          filter(res => !!res)
        )
        .subscribe(() => {

        if (this.savePopover) {
          this.savePopover.close();
        }
        this.errorMsg = '';
        this.saveCartName = this.selectedData?.companyName?.slice(0, 30);
      });

      return;
    }

    if (this.saveCartName) {
      this.errorMsg = 'O nome inserido não é válido. Caracteres especiais não são permitidos, tente novamente.';

      return;
    }

    this.errorMsg = 'Cart name cannot be blank';
  }

  exportXls(): void {
    const cartProducts = [];
    const unit = this.selectedChannel === PriceChannel.PUBLIC ? '(menor un)' : '(un)';

    this.productEntries.forEach((entries: CustomCartItemEntry) => {
      cartProducts.push({
        [this.eanTranslation]: entries?.product?.sapEan,
        [`${this.unitsTranslation} ${unit}`]: entries?.quantity,
        [this.shipToTranslation]:
          `(${this.selectedData?.cnpjNumber})` +
          this.selectedData?.line1 +
          ', ' +
          (this.selectedData?.line2
            ? this.selectedData?.line2 + ', '
            : '') +
          this.selectedData?.town +
          ', ' +
          this.selectedData?.postalCode,
      });
    });

    this.addToCart.downloadXls(cartProducts, this.cartTranslation);
  }

  omit_special_char(event) {
    this.errorMsg = '';
    return new RegExp(SPECIAL_CHARS_OMIT).test(event.key);
  }

  setDeliveryDate(): void {
    this.minDeliveryDate.setDate(this.minDeliveryDate.getDate());

    if (this.minDeliveryDate.getDay() === 0 || this.minDeliveryDate.getDay() === 6) {
      for (let i = 1; i <= 3; i++) {
        this.minDeliveryDate.setDate(this.minDeliveryDate.getDate() + 1);
        if (this.minDeliveryDate.getDay() !== 0 && this.minDeliveryDate.getDay() !== 6) {
          break;
        }
      }
    }
    this.maxDeliveryDate.setDate(this.minDeliveryDate.getDate() + 6);

    this.deliveryDate = this.minDeliveryDate;
  }

  setPickupDate(): void {
    if (this.currentTime < 12) {
      // Date Set
      this.minPickupDate.setDate(this.minPickupDate.getDate());

      this.pickupSetDate();
    } else {
      this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);

      this.pickupSetDate();
    }
    this.pickupDate = this.minPickupDate;
  }

  ngOnDestroy(): void {
    this.prodAddedSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.removeEntriesSub?.unsubscribe();
    this.deleteCartSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.checkoutDetailsSub?.unsubscribe();
    this.checkoutFailedSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.changedLocSub?.unsubscribe();
    this.saveCartInvalidSub?.unsubscribe();
    this.saveCartSuccessSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.saveRemovedSub?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
    this.translations?.unsubscribe();
  }

  closeDisclaimerAlert() {
    this.showDisclaimer = false;
  }

  calculateNumberOfCartons(productEntry: any): number {
    return productEntry?.quantity / productEntry?.product?.numberOfUnitsPerCarton;
  }

  private addUnits(): Observable<string> {
    const unit = this.selectedChannel === PriceChannel.PUBLIC ? '(menor un)' : '(un)';
    return this.translationService
      .translate('plp.units')
      .pipe(map((translation) => `${translation} ${unit}`));
  }

  private processErrorMessage(errors: any): void {
    this.insufficientStockProducts = new Map();
    errors.slice(1).forEach((error: any) => {
      if (error.message) {
        this.insufficientStockProducts.set(+error.message, +error.reason);
      }
    });
    this.quantityBtnDisabled = true;
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private updateQuantityEntriesData(entryNum: number, quantityValue: string): void {
    const params = { entryNumber: entryNum, quantity: quantityValue };
    if (this.updateEntriesData.some(({ entryNumber }) => entryNumber === params.entryNumber)) {
      this.updateEntriesData[this.updateEntriesData.findIndex((el: any) => el.entryNumber === params.entryNumber)] = params;
    } else {
      this.updateEntriesData = [...this.updateEntriesData, params];
    }
  }

  private checkMaxQuantities(entryNumber: number, newQuantity: number): void {
    this.quantityBtnDisabled = false;
    const maxQuantity: number = this.getMaxQuantity(entryNumber);

    if (maxQuantity !== undefined && maxQuantity < newQuantity) {
      this.quantityBtnDisabled = true;
      return;
    }

    this.checkQuantitiesForAllProducts();
  }

  private checkQuantitiesForAllProducts(): void {
    this.productEntries.every((entry: CustomCartItemEntry) => {
      const productCode = entry.entryNumber;
      const inputElement = document.getElementById(`prodQuantity${productCode}`) as HTMLInputElement;
      const quantity: number = +inputElement.value;
      const maxQuantity: number = this.getMaxQuantity(entry.entryNumber);
      if (maxQuantity !== undefined && maxQuantity < quantity) {
        this.quantityBtnDisabled = true;
        return false;
      }

      return true;
    });
  }

  private cartErrorsHandler(): void {
    this.saveRemovedSub = this.addToCart.saveRemovedItems$.subscribe((saveRemovedItem: any) => {
      if (!saveRemovedItem?.removedEntries?.cartModifications) {
        return;
      }

      saveRemovedItem?.removedEntries?.cartModifications.forEach(cartModification => {
        this.globalMessage.add(cartModification?.statusMessage, GlobalMessageType.MSG_TYPE_ERROR, MESSAGE_TIMEOUT);
      });
    });
  }

  private generateProductEntries(stdCartDetails: Cart[], data: CartsApi): void {
    stdCartDetails.forEach(cartDetails => {
      cartDetails.entries.forEach(entries => {
        const removedEntry = !!(data?.removedEntries?.cartModifications ?? []).filter(cartModification => {
          return entries?.product && cartModification?.entry?.product && entries.product.code === cartModification.entry.product.code;
        }).length;

        if (removedEntry) {
          this.quickOrderRemovedEntry = true;
          return;
        }

        this.quickOrderRemovedEntry = false;

        const conditionsForCartonsLogicMeet = ProductUtils.channelPrivateAndNumberUnitsPerCartonMoreThanOne(
          entries.product.numberOfUnitsPerCarton,
          this.selectedChannel
        );

        const imagesFormat = _.clone(_.findWhere(entries.product?.images, { format: 'thumbnail' }));

        if (imagesFormat) {
          imagesFormat.url = this.baseUrl + imagesFormat?.url;
        }

        const cartItemWithProperQuantity = ProductUtils.checkIfQuantityIsCorrect(conditionsForCartonsLogicMeet, entries, this.globalMessage);

        if (cartItemWithProperQuantity.quantity !== entries.quantity && this.selectedChannel === PriceChannel.PRIVATE) {
          this.shouldUpdateCart = true;
          this.updateTotal = true;
          this.updateQuantityEntriesData(entries.entryNumber, cartItemWithProperQuantity.quantity.toString());
        }

        this.images = { PRIMARY: imagesFormat };
        this.productEntries.push({ ...cartItemWithProperQuantity, ...this.images, conditionsForCartonsLogicMeet });
      });

      this.addToCart.saveRemovedItems.next(false);
    });
  }

  private getTranslations(): void {
    this.translations = combineLatest([
      this.translationService.translate('orderDetail.ean'),
      this.translationService.translate('orderDetail.shipTo'),
      this.translationService.translate('orderDetail.cart'),
      this.translationService.translate('plp.units'),
    ]).subscribe(([ean, shipTo, cart, units]) => {
      this.eanTranslation = ean;
      this.shipToTranslation = shipTo;
      this.cartTranslation = cart;
      this.unitsTranslation = units;
    });
  }

  private onCartUpdate(): void {
    this.cartDetailsSub = this.addToCart.cartDetailsHot$.subscribe((res: any) => {
      if (!res) {
        return;
      }

      this.addToCart.removedEntries(this.cartId, this.addToCart.userId);
      this.addToCart.removeEntriesMapping();
      this.updateTotal = false;
      const stdCartDetails = res?.childCarts.filter((item) => item.cartType === CartType.STANDARD);
      this.standardCartDetails = Object.assign({}, ...stdCartDetails);
      this.updateEntriesData = [];
      this.shouldUpdateCart = false;
      this.cdr.detectChanges();
    });
  }

  private pickupSetDate(): void {
    if (this.minPickupDate.getDay() === 0 || this.minPickupDate.getDay() === 6) {
      for (let i = 1; i <= 3; i++) {
        this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
        if (this.minPickupDate.getDay() !== 0 && this.minPickupDate.getDay() !== 6) {
          break;
        }
      }
    }
    this.maxPickupDate.setDate(this.minPickupDate.getDate() + 6);
  }
}
